import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";
import { Agreement } from "@modules/agreements/types";
import { PromocodeBatch } from "@modules/promocodeBatches/types";

export const usePromocodesListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  promocodeModalRef: RefObject<ModalRef>,
  agreements?: Agreement[],
  batches?: PromocodeBatch[],
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "batch",
        headerName: translate("promocode_admin.fields.batch"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={batches?.find(batch => batch.id === value)?.name}
          />
        ),
      },
      {
        field: "code",
        headerName: translate("promocode_admin.fields.code"),
        minWidth: 150,
        flex: 0.5,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "agreement",
        headerName: translate("promocode_admin.fields.agreement"),
        minWidth: 250,
        flex: 0.5,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/agreement/edit/${value}`}
            value={agreements?.find(agreement => agreement.id === value)?.name}
          />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => promocodeModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, promocodeModalRef, batches, agreements],
  );
};
